// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"MyDropdownMenu_dropdownContainer__dG27W","addToCartButton":"MyDropdownMenu_addToCartButton__uYyuA"};